export const ENDPOINTS = {
  esignDocument: `/esign-document`,
  findByPhone: `/customer/find-by-phone`,
  paymentsNonRO: `/payment`,
  signedDocumentVerification: `/signed-document-verification`,
};
